import configurationSetPliIntervalTypes from '@/constants/configuration-set-pli-interval-types.js'
import { formatPliInterval, pliIntervalDistanceValues, pliIntervalTimeValues } from '@/utils/pli-interval.js'

// The dropdown labels come from the same formatter the read-only screens use,
// so a new interval only needs adding to the value list in the util.
const pliIntervalTimes = Object.fromEntries(
    pliIntervalTimeValues.map((value) => [
        value,
        `Every ${formatPliInterval(configurationSetPliIntervalTypes.TIME, value).label}`,
    ])
)

const pliIntervalDistances = Object.fromEntries(pliIntervalDistanceValues.map((value) => [value, `${value}m`]))

export default {
    data() {
        return {
            defaultPliIntervalTime: 5,
            defaultPliIntervalDistance: 25,
            defaultPliJitterValue: 0,
            pliIntervalTimes,
            pliIntervalDistances,
            pliJitterValues: {
                0: 'None',
                5: '5%',
                10: '10%',
                15: '15%',
                20: '20%',
                25: '25%',
            },
            pliIntervalTabIndex: 0,
            pliIntervalTabs: [configurationSetPliIntervalTypes.TIME, configurationSetPliIntervalTypes.DISTANCE],
            pliEnabled: false,
        }
    },

    methods: {
        setTab(intervalType) {
            const index = this.pliIntervalTabs.indexOf(intervalType)
            if (index !== -1) {
                this.pliIntervalTabIndex = index
            }
        },
    },
}
